module.exports = __webpack_public_path__ + "img/benefits02-02.1576709.png";